import { gql } from '@apollo/client'
import {taskData, userDataCompressed} from '../../../common/fragments'

export const GET_TASKS = gql`
	query getContactTasks(
		$contact_id: ID
		$thumbnailResolution: String = "128x128"
	) {
		getContactTasks(input: { contact_id: $contact_id }) {
			id
			type_id
			description
			assigned_by_user_id
			approval_required
			approved_by_user_id
			approval_at
			due_at
			is_completed
			created_by
			created_at
			modified_by
			modified_at
			is_deleted
			task_status_id

			# task_x_assigned_to
			assigned_to_type
			assigned_to_users {
				...userDataCompressed
				department
				is_deleted
			}
			assigned_to_department {
				id
				value
			}
		}
	}
	${userDataCompressed}
`

export const CREATE_TASK = gql`
	mutation createContactTask(
		$CreateTaskInput: CreateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		createContactTask(input: $CreateTaskInput) {
			code
			success
			message
			task {
				...taskData
			}
		}
	}
	${taskData}
`

export const DELETE_TASK = gql`
	mutation deleteContactTask($id: ID) {
		deleteContactTask(id: $id) {
			code
			success
			message
		}
	}
`

export const UPDATE_TASK = gql`
	mutation updateContactTask(
		$UpdateTaskInput: UpdateTaskInput!
		$thumbnailResolution: String = "128x128"
	) {
		updateContactTask(input: $UpdateTaskInput) {
			code
			success
			message
			task {
				id
				type_id
				description
				assigned_by_user_id
				approval_required
				approved_by_user_id
				approval_at
				due_at
				is_completed
				created_by
				created_at
				modified_by
				modified_at
				is_deleted
				task_status_id

				# task_x_assigned_to
				assigned_to_type
				assigned_to_users {
					...userDataCompressed
					department
					is_deleted
				}
				assigned_to_department {
					id
					value
				}
			}
		}
	}
	${userDataCompressed}
`
